module.exports = __webpack_public_path__ + "img/help_nav.60da2939.jpg";